import { cn } from '@/lib/utils'
import { pillBtnBase } from '@/components/roostr'

// Header page-nav pill group — design shell.jsx Header navBtn (2026-07-16
// revision): Explore · Searches · Liked · What's new sit right of the search
// input as labeled pills. Compact mode collapses labels to icons-only with
// tighter padding. The compact threshold is 2100px, NOT the design's 1240:
// the search input is pinned to 50vw (user top-priority 2026-07-16), and the
// labeled cluster (right cluster ~726px in Czech, the worst case) only fits
// beside it from ~2056px — measured live, threshold rounded up.
export function navPillCls(active: boolean) {
  return cn(
    pillBtnBase,
    'relative px-[11px] py-[9px] text-[13.5px] min-[2100px]:px-3.5',
    active ? 'bg-primary-container text-on-primary-container' : 'text-ink-secondary hover:bg-surface-low'
  )
}

// Counter chip on a nav pill. Labeled mode = inline after the label (design
// navBtn badge); compact mode = corner overlay (design BottomNav badge), so
// a maxed "99+" badge never widens the icons-only cluster — the 50vw search
// guarantee leaves no slack for that at the lg rung.
const navPillBadgeBase =
  'absolute -right-1 -top-1 inline-flex h-[17px] min-w-[17px] items-center justify-center rounded-full px-1 font-mono text-[10.5px] font-bold min-[2100px]:static'

// Red badge — reserved for "needs your attention" (unread notifications).
export const navPillBadgeCls = cn(navPillBadgeBase, 'bg-primary text-white')

// Neutral badge — plain inventory counts (liked flats, saved searches). These
// are standing totals, not alerts: three red badges in a row made everything
// look urgent and drowned out the one that actually is (user 2026-08-04).
// The ring keeps the chip legible in compact mode, where it overlays the
// header surface instead of sitting inline on the pill.
export const navPillBadgeNeutralCls = cn(
  navPillBadgeBase,
  'bg-surface-high text-ink-secondary ring-1 ring-outline-variant'
)

// Pill label — hidden in compact mode.
export const navPillLabelCls = 'hidden min-[2100px]:inline'
